import axios from 'axios';

const getRespostas = (idCotacao, params) => axios.get(`/cotacoes/${idCotacao}/respostas-cotacoes`, { params });
const getProdutos = (idCotacao, params) => axios.get(`/cotacoes/${idCotacao}/respostas-cotacoes-produtos`, { params });
const getResposta = (idCotacao, idResposta) => axios.get(`/cotacoes/${idCotacao}/respostas-cotacoes/${idResposta}`);
const getRespostasProdutos = (idCotacao, params) => axios.get(`/cotacoes/${idCotacao}/respostas-cotacoes-produtos/fornecedores`, { params });
const getSemEstoque = idCotacao => axios.get(`/cotacoes/${idCotacao}/respostas-cotacoes/sem-estoque`);
const favoritar = (idCotacao, idResposta) => axios.put(`/cotacoes/${idCotacao}/respostas-cotacoes/${idResposta}/favoritar`, {});
const enviarEmail = (idCotacao, idResposta) => axios.post(`/cotacoes/${idCotacao}/respostas-cotacoes/email/${idResposta}`, {});
const enviarWhatsapp = (idCotacao, idResposta) => axios.post(`/cotacoes/${idCotacao}/respostas-cotacoes/whatsapp/${idResposta}`, {});
const enviarTodosEmails = idCotacao => axios.post(`/cotacoes/${idCotacao}/respostas-cotacoes/email/all`, {});
const enviarTodosWhatsapp = idCotacao => axios.post(`/cotacoes/${idCotacao}/respostas-cotacoes/whatsapp/all`, {});
const getHistorico = (idCotacao, idResposta) => axios.get(`/cotacoes/${idCotacao}/respostas-cotacoes/${idResposta}/historico`);

export default {
  getRespostas,
  getProdutos,
  getResposta,
  getRespostasProdutos,
  getSemEstoque,
  favoritar,
  enviarEmail,
  enviarWhatsapp,
  enviarTodosEmails,
  enviarTodosWhatsapp,
  getHistorico,
};
